module.exports = __webpack_public_path__ + "img/people-outline.png";